import { Component, EventEmitter, Inject, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { GridColumnModel, GridComponent, ExcelExportProperties, SearchSettingsModel } from '@syncfusion/ej2-angular-grids';
import { DataManager, ODataV4Adaptor } from '@syncfusion/ej2-data';
import { UserRoles } from 'projects/sales/src/app/shared/constants/app.constants';
import { SharedService } from 'projects/shared/src/lib/shared.service';
import { APP_CONFIG, AppConfig } from 'projects/shared/src/lib/app-config.token';
import { getExcelDataSource, gridActionBeginForFilteringOdataV4, gridActionsForFiltering, updateFilterIcon } from 'projects/shared/src/lib/utils/grid-functions';
import { getCurrentDate } from 'projects/shared/src/lib/utils/date-functions';


let MASTER_API_URL = '';
@Component({
    selector: 'app-vr-resources-popup',
    templateUrl: './vr-resources-popup.component.html',
    styleUrls: ['./vr-resources-popup.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class VrResourcesPopupComponent implements OnInit {

  isExpanded: boolean = false;
  allAddressesData: any;
  @Output() onClose = new EventEmitter();


  AddressesGridColumns: GridColumnModel[];
  @ViewChild('columnChooserForGrid') columnChooserForGrid!: any;
  // gridName = gridNames.myProfileAddressesGrid;
  AddressesPopupGrid!: GridComponent;
  pageSettings: any;
  searchSettings: SearchSettingsModel;
  showUserProfilePopup: boolean;
  userProfile: any;
  @ViewChild('AddressesPopupGrid') set gridComponent(gridComponent: GridComponent) {
    if (gridComponent) {
      this.AddressesPopupGrid = gridComponent;
      this.AddressesPopupGrid.toolbar = this.getAddressesGridToolbar();
    }
  }

  // UserRoles: typeof UserRoles;



  constructor(
    private sharedService: SharedService,
    @Inject(APP_CONFIG) private config: AppConfig,
  ) {
    MASTER_API_URL = config.masterApiURL;
    this.AddressesGridColumns = this.getAddressesGridColumns();
   }

  ngOnInit() {
    this.pageSettings = { pageSizes: [20,50,100,500], pageSize: 20 };
    this.allAddressesData = new DataManager({
      url: `${MASTER_API_URL}${this.config.appName === 'sales' ? '/odata/EmployeesByManager?areaType=Territory,District' : '/odata/ServiceEmployeesByManager'}`,
      adaptor: new ODataV4Adaptor(),
      headers: [{ "Authorization": `Bearer ${localStorage.getItem('access_token')}` }]
    });

  }
  created($event: any) {
    updateFilterIcon({ requestType: 'filtering' }, this.AddressesPopupGrid);
    if(this.config.appName === 'sales') {
      this.searchSettings = {
        fields: [
          "userId",
          "employeeName",
          "territoryName",
          "districtName",
          "regionName",
          "districtManager",
          "regionManager"
        ]
      } 
    } else {
      this.searchSettings = {
        fields: [
          "userId",
          "employeeName",
          "role",
          "serviceDepartment",
          "manager"
        ]
    }
    };
  }
  openUserProfile(data: any) {
    this.showUserProfilePopup = true;
    data["name"] = data?.employeeName;
    this.userProfile = data;
  }
  getAddressesGridColumns() {
    const columns =[
      {
        field: 'Actions', headerText: 'Select', showInColumnChooser: false,  width: 80, allowEditing: false, textAlign: 'Center', allowFiltering: false, allowSorting: false, freeze: 'Left', allowReordering: false,
        commands: [
          { title: 'Select', buttonOption: { iconCss: `fas fa-arrow-right`, cssClass: 'e-flat' } }
        ]
      },
      { field: 'userId', headerText: 'ID', type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: false },
      { field: 'employeeName', headerText: 'Name', type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
      
    ] as GridColumnModel[];
    if(this.config.appName === 'sales') {
      columns.push(
        { field: 'territoryName', headerText: 'Territory', type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
        { field: 'districtName', headerText: 'District', type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
        { field: 'regionName', headerText: 'Region', type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
        { field: 'districtManager', headerText: 'District Manager', type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
        { field: 'regionManager', headerText: 'Region Manager', type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
      );
    }
    else {
      columns.push(
        { field: 'role', headerText: 'Role', type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
        { field: 'serviceDepartment', headerText: 'Service Department', type: 'string', allowEditing: false, textAlign: 'Left', width: 200, visible: true, showInColumnChooser: true },
        { field: 'manager', headerText: 'Manager', type: 'string', allowEditing: false, textAlign: 'Left', width: 120, visible: true, showInColumnChooser: true },
      );
    }
  return columns;
  }
  commandColumnClick(args: any) {
    let rowData = args.rowData;
    if (args.commandColumn.title === 'Select') {
      this.onClose.emit(rowData);
    }
  }

  onToolbarClick(args: any) {
    if (args.item.id === 'excel-export') {
      const dataSource = getExcelDataSource(this.AddressesPopupGrid);
      let excelExportProperties: ExcelExportProperties = {
        dataSource,
        hierarchyExportMode: 'Expanded',
        theme: {
          header: { bold: true, backColor: '#eeeeee', fontSize: 15 }
        },
        fileName: `Warehouse Addresses (${getCurrentDate()}).xlsx`
      };
      this.AddressesPopupGrid.excelExport(excelExportProperties);
    } else if (args.item.id === 'clear-filter') {
      this.AddressesPopupGrid.clearFiltering();
      this.AddressesPopupGrid.clearSorting();
      this.AddressesPopupGrid.search('');
      this.AddressesPopupGrid.refresh();
    }
  }

  onGridActionBegin(args: any, grid?: any) {
    gridActionBeginForFilteringOdataV4(args);
  }

  onActionComplete(args: any, grid: GridComponent) {
    gridActionsForFiltering(args, grid);
    updateFilterIcon(args, this.AddressesPopupGrid);
  }

  getAddressesGridToolbar(): any {
    let tb = [
      { text: '', id: 'column-chooser', align: 'Left', template: this.columnChooserForGrid, tooltipText: 'Show/Hide Columns' },
      'Search',
      { text: '', id: 'clear-filter', align: 'Right', prefixIcon: 'fas fa-filter', cssClass: 'grid-filter-icon', tooltipText: 'Clear all Filters' }
    ];
    
    if (this.sharedService.getUSER()?.role !== UserRoles.salesRep) {
      const indexExcelExport = tb.findIndex(fi => fi == 'Search');
      tb.splice(indexExcelExport + 1, 0, { text: '', id: 'excel-export', align: 'Right', prefixIcon: 'e-excelexport', cssClass: `grid-add-button`, tooltipText: 'Excel Export' })
    }
    return tb;
  }

  close() {
    this.onClose.emit(true);
  }

  isChanged() {
    return true;
  }

  expandCollapse() {
    this.isExpanded = !this.isExpanded;
  }

}
